module.exports = __webpack_public_path__ + "Gotham-Book.otf?9019ab71e2d2d6cc3c9f4140cb27a618";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Gotham-Book.otf
// module id = 308
// module chunks = 0